import React, { useEffect, useState } from 'react'
import NavigationBar from '../../../components/Navigationbar/Navigationbar'
import Sidebar from '../../../components/Sidebar/Sidebar'
import Headline from '../../../components/headline/Headline'
import { Box, Tab, tabClasses, TabList, TabPanel, Tabs, Typography } from '@mui/joy';
import Switch from '@mui/material/Switch';
import BestTarif from './components/BestTarif';
import { post, Token } from '../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import VergleichCreator from './components/VergleichCreator';
function VergleichHome() {
    const [wit, setwith] = useState("90.5%");
    const [index, setIndex] = React.useState(0);
    const [data,setdata] = useState();
    const navigate = useNavigate();
    useEffect(() => {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        let response = post(body,"/vergleichen")
        if (response == "LOGOUT"){
            navigate("/");
            return;
        }
        const prased = JSON.parse(response);
        setdata(prased);
    }, []);
    return (
        <>
            <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", height: "100vh", display: "flex", alignItems: "center" }}>
                <Box sx={{ display: "flex", mt: 0, flexDirection: "row", justifyContent: "space-between", width: "100%" }}>
                    <Tabs
                        aria-label="Pipeline"
                        value={index}
                        onChange={(event, value) => {
                            setIndex(value)
                        }}
                        sx={{ mt: 0, width: "100%", height: "100vh" }}
                    >
                        <TabList
                            sx={{
                                pt: 1,
                                justifyContent: 'center',
                                [`&& .${tabClasses.root}`]: {
                                    flex: 'initial',
                                    bgcolor: 'transparent',
                                    '&:hover': {
                                        bgcolor: 'transparent',
                                    },
                                    [`&.${tabClasses.selected}`]: {
                                        color: 'primary.plainColor',
                                        '&::after': {
                                            height: 2,
                                            borderTopLeftRadius: 3,
                                            borderTopRightRadius: 3,
                                            bgcolor: 'primary.500',
                                        },
                                    },
                                },
                            }}
                        >
                            <Tab
                                variant="soft"
                                color="neutral">Vergleichen</Tab>
                            <Tab
                                variant="soft"
                                color="neutral">Besten Tarif ermitteln</Tab>
                        </TabList>
                        <TabPanel sx={{overflowY: "auto"}} value={1}><BestTarif data={data}/></TabPanel>
                        <TabPanel sx={{overflowY: "auto"}} value={0}><VergleichCreator data={data}/></TabPanel>
                    </Tabs>
                </Box>


            </div>
            <Sidebar />
            <NavigationBar state={"vergleiche"} back={true} />
        </>
    )
}

export default VergleichHome
